module.exports = __webpack_public_path__ + "images/206318a2d7807de98cc26a186c1201c1-TourismCaresLogo_2021.png";